import { JSX } from 'preact'
import { WidgetInstance } from '../../types'
import defaultStylesV2 from '../../assets/styles/default-v2.less'
import { UserStyle } from './UserStyle'
import { RegisteredStyles } from './RegisteredStyles'

const baseStyles = defaultStylesV2({})

interface Props {
  widget: WidgetInstance
}

export function StylesV2({ widget }: Props): JSX.Element {
  const { styles = [], css = '' } = widget.data || {}

  return (
    <>
      <style>{baseStyles}</style>
      <RegisteredStyles initial={styles} />
      {css && <UserStyle css={css} />}
    </>
  )
}
